import React from 'react';
import PlayImage from './assets/Image-Play.png';
import RegisterImage from './assets/Image-Register.png';
import WinImage from './assets/Image-Win.png';
import './EasyToPlaySection.scss';

const EasyToPlaySection = props => {
  return (
    <div className="cv-landing-easy-to-play-section-wrapper">
      <h1>It’s Easy to Play</h1>
      <div className="cv-landing-play-section-cards">
        <div className="cv-landing-content-card">
          <div className="cv-landing-content-card-image register-image">
            <img src={RegisterImage} className="register" alt="" />
          </div>
          <div className="cv-landing-content-card-text">
            <h3>Register</h3>
            <p>Fast, easy, and free. No credit card required.</p>
          </div>
        </div>
        <div className="cv-landing-play-section-arrow"></div>
        <div className="cv-landing-content-card">
          <div className="cv-landing-content-card-image play-image">
            <img src={PlayImage} className="play" alt="" />
          </div>
          <div className="cv-landing-content-card-text">
            <h3>Play</h3>
            <p>Start playing your favorite games immediately.</p>
          </div>
        </div>
        <div className="cv-landing-play-section-arrow"></div>
        <div className="cv-landing-content-card">
          <div className="cv-landing-content-card-image win-image">
            <img src={WinImage} className="win" alt="" />
          </div>
          <div className="cv-landing-content-card-text">
            <h3>Win</h3>
            <p>
              Earn points, select rewards, and redeem at your favorite Wind
              Creek location.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EasyToPlaySection;
